export class GraphQLError extends Error {}
